import { render, staticRenderFns } from "./wallet_bank.vue?vue&type=template&id=2fcdcf3c&scoped=true"
import script from "./wallet_bank.vue?vue&type=script&lang=js"
export * from "./wallet_bank.vue?vue&type=script&lang=js"
import style0 from "./wallet_bank.vue?vue&type=style&index=0&id=2fcdcf3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcdcf3c",
  null
  
)

export default component.exports